import StorageUtility from './storage-utility';

const RecentTeamIdsKey = 'recentTeamIds';
const MaxRecentTeams = 5;


const PersonalizationUtility = {
  addRecentTeamId: (teamId) => {
    if (!teamId) return;

    const recentTeamIds = PersonalizationUtility.getRecentTeamIds();
    if (recentTeamIds.indexOf(teamId) !== -1) return;

    recentTeamIds.unshift(teamId);
    StorageUtility.set(RecentTeamIdsKey, recentTeamIds.slice(0, MaxRecentTeams));
  },
  getRecentTeamIds: () => {
    const recentTeamIdsString = StorageUtility.get(RecentTeamIdsKey) || '';
    if (!recentTeamIdsString) return [];

    return recentTeamIdsString.split(',');
  },
};

export default PersonalizationUtility;
